import { Component, OnInit, Input } from '@angular/core';
import { Component as BrComponent, Page } from '@bloomreach/spa-sdk';
import { Logger } from '@utils/logger';

const logger = Logger.getLogger('IndCalculatorsComponent');

@Component({
  selector: 'ft-ind-calculators',
  templateUrl: './ind-calculators.component.html',
  styleUrls: ['./ind-calculators.component.scss'],
})
export class IndCalculatorsComponent implements OnInit {
  @Input() component!: BrComponent;
  @Input() page: Page;
  categories: any = [];
  contentType = '';
  title = '';

  constructor() {
    // This is intentional
  }

  ngOnInit(): void {
    this.contentType = this.component?.getParameters().contentType;
    logger.debug('contentType >>>', this.contentType);
  }
}
